// purchaseStatusDetailedReportSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: null,
    buys: [],
    groupedData: [],
    summary: {
      totalSales: 0,
      totalTransactions: 0,
      dateRange: "",
    },
  },
  loading: false,
  error: null,
};

const purchaseStatusDetailedReportSlice = createSlice({
  name: "purchaseStatusDetailedReport",
  initialState,
  reducers: {
    purchaseStatusReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    purchaseStatusReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload.data;
    },
    purchaseStatusReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetPurchaseStatusReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    },
  },
});

export const {
  purchaseStatusReportRequest,
  purchaseStatusReportSuccess,
  purchaseStatusReportFailure,
  resetPurchaseStatusReport,
} = purchaseStatusDetailedReportSlice.actions;

export default purchaseStatusDetailedReportSlice.reducer;
